import React from "react";
import { Document, Page, Text, StyleSheet, View, Font } from "@react-pdf/renderer";
import robotoBoldItalic from "./fonts/Roboto-BoldItalic.ttf";
import robotoRegular from "./fonts/Roboto-Regular.ttf";
import robotoBold from "./fonts/Roboto-Bold.ttf";
import { formatCapital } from "../../../../utils/utils";

Font.register({
  family: "Roboto",
  fonts: [
    { src: robotoRegular },
    { src: robotoBoldItalic, fontWeight: "bold", fontStyle: "italic" },
    { src: robotoBold, fontWeight: "bold" },
  ]
});

export const PDFConvenio = ({ convenio, radicacion, montoOrigen, montoInteres, honorarios, fechaActual }) => {
  //const honor = ( +convenio.convenio_convpp[0].montoOrigen + +convenio.convenio_convpp[0].montoInteres ) * +convenio.estporc;
  const montoTotalOrigen = +montoOrigen + +montoInteres;
  const honor = montoTotalOrigen * +convenio.estporc;
  const gastFij = +convenio.estgstfijo;
  const gastTotales = honor + gastFij;

  return ( 
    <Document>
      <Page size="A4" style={styles.body}>
        <View style={styles.section}>
          <Text style={styles.principalTitle} key={"principalTitle"}>
            CONVENIO DE MODALIDAD DE PAGO NRO {convenio.id}
          </Text>
        </View>
        <View style={styles.section}>
          <Text style={{...styles.ident, ...styles.textJustify}}>
            En la ciudad de San Nicolás de los Arroyos, Partido del mismo nombre, Provincia de Buenos Aires, por una parte la Municipalidad de San Nicolás de los Arroyos,
            representada en este acto por el/la Abg. {convenio?.convenio_abogado?.apellido}, {convenio?.convenio_abogado?.nombre}, matrícula 
            {convenio?.convenio_abogado?.matricula}, en su carácter de apoderado/a fiscal conforme convenio dispuesto por Ordenanza Nº 8203/12,
            con domicilio procesal en {convenio?.convenio_abogado?.direccion} de San Nicolás, en adelante {"'La Municipalidad'"};
            y por la otra el/la Sr/a. {convenio?.convenio_convfirma?.nombre}, DNI {convenio?.convenio_convfirma?.dni},
            en su carácter de {convenio?.convenio_convfirma?.convcaracter?.nombre}, con domicilio real en {convenio?.convenio_convfirma?.direccion}, 
            {convenio?.convenio_convfirma?.localidad}, cel. {convenio?.convenio_convfirma?.telefono} y en adelante {"'El Contribuyente'"}, acuerdan celebrar el presente 
            CONVENIO DE MODALIDAD DE PAGO, sujeto a las siguientes cláusulas y condiciones:
          </Text>
        </View>
        <View style={styles.section}>
          <Text style={{...styles.ident, ...styles.textJustify}}>
            <Text style={{...styles.bold,...styles.ident}}>
              Primera:
            </Text>
            <Text>
              El presente tiene causa fuente en las deudas de Tasas y/o Gravámenes Municipales a cargo del contribuyente que más adelante se detallan a saber:
            </Text>
          </Text>
        </View>
        <View style={styles.section}>
          { getResumenCuotas(convenio) }
        </View>
        <View style={styles.section}>
          <Text style={{...styles.ident, ...styles.textJustify}} key={"SegundaTextContainer"}>
            <Text style={{...styles.bold,...styles.ident}} key={"SegundaText1"}>
              Segunda:
            </Text>
            <Text key={"SegundaText2"}>
              Las partes reconocen y aceptan que la deuda reclamada asciende a la suma de $ {formatCapital(montoTotalOrigen)} y estipulan la siguiente forma de pago:
            </Text>
          </Text>
        </View>
        {convenio?.convenio_convpp?.length > 0 && (
          <View style={styles.section}>
            {
              getConvenioPlanesPago(convenio.convenio_convpp, fechaActual.mesInt)
            }
          </View>
        )}
        <View style={styles.section}>
          <Text style={{...styles.ident, ...styles.textJustify}}>
            <Text style={{...styles.bold,...styles.ident}}>
              Tercera:
            </Text>
            <Text>
              En caso de haberse acordado un plan de financiacion en cuotas, las partes acuerdan que la presente liquidación es al sólo efecto de composición de intereses por los períodos detallados en el 
              acápite primero, sujeto a la condición del estricto cumplimiento del presente convenio y en especial al pago en tiempo de cada una 
              de las cuotas acordadas. La falta de pago de dos (2) cuotas consecutivas y/o alternadas; o transcurridos 90 dias corridos desde el 
              vencimiento de la última cuota exigible producirá la caducidad del plan de pago, siendo la primera fecha de vencimiento la que la origine, 
              todo ello conforme a lo dispuesto por las Ordenanzas 6091/04 y 7577.
            </Text>
          </Text>
        </View>
        <View style={styles.section}>
          <Text style={{...styles.ident, ...styles.textJustify}}>
            Asimismo, al 31 de diciembre de cada año, no deberá registrar deuda en concepto de los presentes tributos por los períodos cuyos vencimientos operen 
            con posterioridad a los comprendidos en el presente plan de pago. Caso contrario se producirá sin sustanciación alguna, la caducidad del plan de pago. 
          </Text>
        </View>
        <View style={styles.section}>
          <Text style={{...styles.ident, ...styles.textJustify}}>
            Cualquiera de estas situaciones facultará a la Municipalidad de San Nicolás, sin necesidad de notificación previa, a iniciar y/o continuar el 
            correspondiente juicio de apremio por el total de lo adeudado e imputando los pagos que se hubieren efectuado a la deuda más antigua, o su expresa voluntad 
            solicitar la homologación y ejecución del presente convenio.          
          </Text>
        </View>
        <View style={styles.section}>
          <Text style={{...styles.ident, ...styles.textJustify}}>
            <Text style={{...styles.bold,...styles.ident}}>
              Cuarta:
            </Text>
            <Text>
              En el caso que el responsable de pago y/o contribuyente resulte ser un tercero interesado, éste se subroga y responsabiliza de manera solidaria al 
              pago de la deuda objeto del presente, por lo que asume la obligación de pagador principal de la deuda reclamada. Tal condición tendrá el carácter de 
              provisorio y quedará supeditada a su eventual reconocimiento judicial o en su defecto al pago total del monto adeudado.          
            </Text>
          </Text>
        </View>
        <View style={styles.section}>
          <Text style={{...styles.ident, ...styles.textJustify}}>
            Sin perjuicio de ello, el presente no exime al titular de dominio de responsabilidad sobre lo reclamado.
          </Text>
        </View>
        <View style={styles.section}>
          <Text style={{...styles.ident, ...styles.textJustify}}>
            <Text style={{...styles.bold,...styles.ident}}>
              Quinta:
            </Text>
            <Text>
              Una vez que se haya finalizado el pago total del presente, las partes darán por terminados sus conflictos de intereses en relación a los 
              períodos arriba detallados.
            </Text>
          </Text>
        </View>
        <View style={styles.section}>
          <Text style={{...styles.ident, ...styles.textJustify}}>
            <Text style={{...styles.bold,...styles.ident}}>
              Sexta:
            </Text>
            <Text>
              Las partes constituyen domicilios, a los efectos del presente, en los indicados en el encabezamiento, donde serán válidas todas las notificaciones 
              y/o comunicaciones que se cursaren.
            </Text>
          </Text>
        </View>
        <View style={styles.section}>
          <Text style={{...styles.ident, ...styles.textJustify}}>
            <Text style={{...styles.bold,...styles.ident}}>
              Séptima:
            </Text>
            <Text>
              Las partes acuerdan costos y costas, en la suma única total de $ { formatCapital(gastTotales) }, que comprenden los siguientes rubros:
              {/* los honorarios profesionales del/la Abg. {convenio.convenio_abogado.apellido}, {convenio.convenio_abogado.nombre} en la suma 
              única y total de: $ {formatCapital(honorarios)} seria la suma de todos los siguientes rubros que comprende: */}
            </Text>
          </Text>
        </View>
        <View>
          <Text style={styles.ident}>
            - Honorarios: $ { formatCapital(honor) } con más IVA de corresponder.
            {/* - Honorarios: $ {montoInteres ? formatCapital(+montoInteres * +convenio.estporc) : formatCapital(+monto * +convenio.estporc)} con más IVA de corresponder. */}
          </Text>
        </View>
        <View>
          <Text style={styles.ident}>
            - Estado del convenio: {`"${convenio.convenio_convestado.nombre}"`} ({100 * +convenio.estporc}% del monto total de la deuda)
            {/* - Estado del convenio: "{convenio.convenio_convestado.nombre}" ({100 * +convenio.estporc}% del monto total de la deuda) */}
          </Text>
        </View>
        <View>
          <Text style={styles.ident}>
            - Gastos fijos: $ { formatCapital(gastFij) }
          </Text>
        </View>
        {/* <View>
          <Text style={styles.ident}>
            - Otros gastos: $ {formatCapital(+convenio.otgastos)}
          </Text>
        </View> */}
        {/* <View>
          <Text style={styles.ident}>
            - IVA de corresponder: % $ { formatCapital(+montoTotal * +convenio.estporc * 0.21)}
          </Text>
        </View> */}
        {/* <View>
          <Text>
            El estado de este convenio es "{convenio.convenio_convestado.nombre}", por el cual los honorarios es el {100 * +convenio.estporc}% del monto total de la deuda $ {formatCapital((+convenio.convenio_convpp[0].montoOrigen + +convenio.convenio_convpp[0].montoInteres))}.
          </Text>
        </View> */}
        {radicacion && (
          <View style={styles.section}>
            <Text style={{...styles.ident, ...styles.textJustify}}>
              <Text style={styles.bold}>
                Caratula , Juzgado y expediente:
              </Text>
              <Text>
                {radicacion?.caratula || ""}. Juzgado Civil y Comercial Nº {radicacion?.juzgado || ""}. Expediente: {radicacion?.nroexpte || ""}
              </Text>
            </Text>
            <View>
              <Text style={styles.listItem}>
                - Aportes de Ley a cargo de la accionada: $ {montoInteres ? formatCapital(+montoInteres * +convenio.estporc * 0.10) : formatCapital(honorarios * 0.10)}
              </Text>
              <Text style={styles.listItem}>
                - Tasa de justicia: $ {formatCapital(montoTotalOrigen * 0.022)}
              </Text>
              <Text style={styles.listItem}>
                - Sobre tasa de Justicia: $ {formatCapital(montoTotalOrigen * 0.022 * 0.10)}
              </Text>
              {/* <Text style={styles.listItem}>
                - Servicios Registrales
              </Text> */}
            </View>
          </View>
        )}
        <View>
          <Text style={{...styles.ident, ...styles.textJustify}}>
            Dichos montos serán abonados por el contribuyente en la forma pactada, acordando la mora automática y sirviendo el presente de 
            título ejecutivo para su posterior reclamo judicial en caso de incumplimiento.
          </Text>
        </View>
        <View>
          <Text style={{...styles.ident, ...styles.textJustify}}>
            En prueba de conformidad, y previa lectura y ratificación, se firman tres (3) ejemplares de un mismo tenor y a un solo efecto,
            en la ciudad de San Nicolás de los Arroyos a los {fechaActual.dia} días del mes de {fechaActual.mesStr} de {fechaActual.anio}.
          </Text>
        </View>
      </Page>
    </Document>
  );
};

const getResumenCuotas = ( convenio) => {
  return convenio?.convenio_convppcuotas?.length > 0 
    ? convenio?.convenio_convpp?.map((convpp, idx) => {
      const planes = convenio?.convenio_convppcuotas?.filter(
        (e) => e.imponible === convpp.imponible && e.recurso === convpp.recurso
      );

      if (!planes || planes.length === 0) return null;

      // Agrupar cuotas por año
      const cuotasPorAnio = planes.reduce((acc, e) => {
        if (!acc[e.anio]) {
          acc[e.anio] = [];
        }
        acc[e.anio].push(e.cuota);
        return acc;
      }, {});
      const textoFinal = [
        "Recurso: " + convpp.recurso + " - " + "Nro " + convpp.imponible,
        ...Object.entries(cuotasPorAnio).map(([anio, cuotas]) => {
          const cuotasOrdenadas = cuotas.sort((a, b) => a - b).join("- ");
          return "Año " + anio + " " + cuotasOrdenadas;
        }),
      ].join(" ");
      return (
        <Text key={idx} style={{...styles.ident, ...styles.textJustify, marginBottom: 5}}>
          {textoFinal}
        </Text>
      );
    })
    : <></>;
};

const getConvenioPlanesPago = (convenio_convpp) => {
// const getConvenioPlanesPago = (convenio_convpp, mesInt) => {
  const recursosInmueble = ["SS", "AB", "PA", "DU"];
  return convenio_convpp.map((convpp, idx) => {
    const isInmueble = recursosInmueble.includes(convpp.recurso);
    return (
      <>
        <View style={styles.section} key={"View1" + idx}>
          <Text style={{...styles.ident, ...styles.textJustify}}>
            Recurso: {convpp.recurso} - Imponible {convpp.imponible} Monto actualizado de la Deuda: $ {formatCapital(+convpp.montoOrigen + +convpp.montoInteres)} que abarca el capital 
            y sus correspondientes intereses (conforme a las Ordenanzas 5358/02; 6091/04 y/o la norma que en su consecuencia se dicte):
          </Text>
        </View>
        <View style={styles.section} key={"View2" + idx}>
          {/* <Text>
            
          </Text> */}
          {
            convpp.cuotas === 1 
              ? isInmueble 
                ? <View>
                  <Text style={{ ...styles.textJustify}}>
                    {/* <Text style={{...styles.ident, ...styles.textJustify}}> */}
                    {/* <Text style={{...styles.ident, ...styles.textJustify}}> */}
                    {/* 1 pago con 20% de descuento sobre intereses resultando un monto final a pagar por el contribuyente de $ {formatCapital(+convpp.montoOrigen + (+convpp.montoInteres * 0.8))}. */}
                    Plan de pago elegido: 1 pago con 20% de descuento sobre intereses resultando
                  </Text> 
                  <Text style={{...styles.ident, ...styles.listItem}}>
                    - CAPITAL: $ {formatCapital(+convpp.montoOrigen)}
                  </Text>
                  <Text style={{...styles.ident, ...styles.listItem}}>
                    - INTERESES: $ {formatCapital(+convpp.montoInteres)}
                  </Text>
                  <Text style={{...styles.ident, ...styles.listItem}}>
                    - 20% DESCUENTO SOBRE INTERESES: - $ {formatCapital(+convpp.montoInteres *0.20)}
                  </Text>
                  {/* <Text style={styles.listItem}>
                    - Monto final a pagar por el contribuyente de $ {formatCapital(+convpp.montoOrigen + (+convpp.montoInteres * 0.8))}
                  </Text> */}
                </View> 
                : <View>
                  <Text style={{ ...styles.textJustify}}>
                    {/* <Text style={{...styles.ident, ...styles.textJustify}}> */}
                    {/* <Text style={{...styles.ident, ...styles.textJustify}}> */}
                    {/* 1 pago con 20% de descuento sobre intereses resultando un monto final a pagar por el contribuyente de $ {formatCapital(+convpp.montoOrigen + (+convpp.montoInteres * 0.8))}. */}
                    Plan de pago elegido: 1 pago
                  </Text> 
                  <Text style={{...styles.ident, ...styles.listItem}}>
                    - CAPITAL: $ {formatCapital(+convpp.montoOrigen)}
                  </Text>
                  <Text style={{...styles.ident, ...styles.listItem}}>
                    - INTERESES: $ {formatCapital(+convpp.montoInteres)}
                  </Text>
                  {/* <Text style={styles.listItem}>
                    - Monto final a pagar por el contribuyente de $ {formatCapital(+convpp.montoOrigen + (+convpp.montoInteres * 0.8))}
                  </Text> */}
                </View> 
              : isInmueble && ((convpp.cuotas === 3) || (convpp.cuotas === 6)) // esto se modificó para ver en caso que sea comercio que tome el valor del monto total y no del montoOrigen+montoInteres
                ? <Text style={{...styles.ident, ...styles.textJustify}}>
                  {/* ? <Text style={{...styles.ident, ...styles.textJustify}}> */}
                  Plan de pago elegido: {convpp.cuotas} cuotas sin interés mensuales y consecutivas de $ {formatCapital((+convpp.monto/+convpp.cuotas).toFixed(2))}, y cuyo primer vencimiento operará el día 10, 
                  o siguiente día hábil, próximo siguiente a la suscripción del presente convenio y las demás los días 10, o siguiente día hábil, de los meses subsiguientes.
                  {/* Plan de pago elegido: {convpp.cuotas} cuotas sin interés mensuales y consecutivas de $ {formatCapital((+convpp.monto/+convpp.cuotas).toFixed(2))}, y cuyo primer vencimiento operará el día 10, 
                  o siguiente día hábil, del mes {mesInt + 1} y las demás en el día 10, o siguiente día hábil, de los meses subsiguientes. */}
                </Text>
                : <Text style={{...styles.ident, ...styles.textJustify}}>
                  Plan de pago elegido: {convpp.cuotas} cuotas con intereses mensuales y consecutivas de $ {formatCapital((+convpp.monto/+convpp.cuotas).toFixed(2))}, y cuyo primer vencimiento operará el día 10, 
                  o siguiente día hábil, próximo siguiente a la suscripción del presente convenio y las demás los días 10, o siguiente día hábil, de los meses subsiguientes.
                  {/* Plan de pago elegido: {convpp.cuotas} cuotas con intereses mensuales y consecutivas de $ {formatCapital((+convpp.monto/+convpp.cuotas).toFixed(2))}, y cuyo primer vencimiento operará el día 10, 
                  o siguiente día hábil, del mes {mesInt + 1} y las demás en el día 10, o siguiente día hábil, de los meses subsiguientes. */}
                </Text>
          }
          <Text style={styles.bold}>
            Total monto financiado según plan de pago elegido: $ {
              convpp.cuotas === 1
                ? isInmueble 
                  ? formatCapital((+convpp.montoOrigen + (+convpp.montoInteres * 0.8)).toFixed(2)) 
                  : formatCapital(+convpp.montoOrigen + +convpp.montoInteres)
                : formatCapital((+convpp.monto).toFixed(2))}
          </Text>
        </View>
      </>
    );
  });
};

// const getMontoTotalOrigen = (convenio_convpp) => {

// }

// En body se separan los padding para que si hace una salto de página mantenga los márgenes superiores e inferiores, porque sino no deja márgenes.

const styles = StyleSheet.create({
  body: {
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop: 60,
    paddingBottom: 60,
    fontSize: 12,
    fontFamily: "Roboto",
    lineHeight: 1.2,
    // textIndent: 50,
  },
  section: {
    marginBottom: 10,
  },
  bold: {
    fontWeight: "bold",
  },
  ident: {
    textIndent: 50,
  },
  principalTitle: {
    textAlign: "center",
    fontWeight: "bold",
  },
  listItem: {
    marginLeft: 40, // Aproximadamente 2cm
    marginBottom: 4,
    textIndent: -10, // Para alinear el guion con el texto
  },
  textJustify: {
    textAlign: "justify",
  },
});